import React from "react";
import { connect } from "react-redux";
import Dropdown from "react-dropdown";
import clientDevices from "../../../API/Client/GetDevices";
import clientMenasOfPayment from "../../../API/Client/GetMeansOfPayment";
import clientArticles from "../../../API/Client/GetArticles";
import { BiAddToQueue } from "react-icons/bi";
import { TiDelete } from "react-icons/ti";
import { AiOutlineSend } from "react-icons/ai";
import Loader from "../../../Global/loader";
import clientIzdavanjeRacuna from "../../../API/Client/PostClientFiscalization";
import { store } from "react-notifications-component";

export class IzdavanjeRacuna extends React.Component {
    state = {
        poruka: null,
        loading: true,
        napUredaji: [],
        naciniPlacanja: [],
        artikli: [],

        listNapUredOption: [],
        listNacinPlacanja: [],
        listArtikli: [],

        pickedNapUred: {},
        pickedNacinPlacanja: {},
        articles: [
            {
                naziv: "",
                kolicina: -1,
                ukupni_iznos: 0.0,
                jedinicna_cijena_mpc: 0,
                uuid: "",
            },
        ],
    };

    componentDidMount = async () => {
        this.setState({
            poruka: "Učitavanje naplatnih uređaja...",
            loading: true,
        });

        const devices = await clientDevices();

        // get Naplatni Uređaji list
        let listOption = [];
        devices.data.map((data) =>
            listOption.push({ label: data.description, value: data.uuid })
        );

        this.setState({
            listNapUredOption: listOption,
        });

        this.setState({ poruka: "Učitavanje načina plaćanja..." });
        const naciniPlacanja = await clientMenasOfPayment();
        // get Nacini placanja list
        listOption = [];
        naciniPlacanja.data.map((data) =>
            listOption.push({ label: data.naziv, value: data.uuid })
        );

        this.setState({
            listNacinPlacanja: listOption,
        });

        this.setState({ poruka: "Učitavanje stavki..." });
        const articles = await clientArticles();
        // get Nacini placanja list
        listOption = [];
        articles.data.map((data) =>
            listOption.push({ label: data.naziv, value: data.uuid })
        );

        this.setState({
            listArtikli: listOption,
        });

        this.setState({ poruka: "Mapiramo..." });

        this.setState({
            napUredaji: devices.data,
            naciniPlacanja: naciniPlacanja.data,
            artikli: articles.data,
            poruka: null,
            loading: false,
        });
    };

    //dropdown naplati uređaj
    setNapUredaj = async (data) => {
        this.state.listNapUredOption
            .filter((napUredaji) => napUredaji.value === data.value)
            .map((filteredData) =>
                //this.props.mapState("CLIENT_MAP_PICKED_NAP_UREDAJ", filteredData)
                this.setState({
                    pickedNapUred: filteredData,
                })
            );
    };

    // dropdown poslovni prostor
    setNacinPlacanja = async (data) => {
        this.state.listNacinPlacanja
            .filter((nacinPlacanja) => nacinPlacanja.value === data.value)
            .map((filteredData) =>
                this.setState({
                    pickedNacinPlacanja: filteredData,
                })
            );
    };

    izdavanjeRacuna = async () => {
        this.setState({ loading: true, poruka: "Račun se šalje..." });

        if (typeof this.state.pickedNapUred.value === "undefined") {
            store.addNotification({
                title: "Greška!",
                message: "Molimo odaberite Naplatni Uređaj",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                    duration: 5000,
                    pauseOnHover: true,
                },
            });
        } else if (
            typeof this.state.pickedNacinPlacanja.value === "undefined"
        ) {
            store.addNotification({
                title: "Greška!",
                message: "Molimo odaberite Naćin Plaćanja",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                    duration: 5000,
                    pauseOnHover: true,
                },
            });
        } else if (
            /*this.state.articles[0].naziv === "" || */ this.state.articles[0]
                .ukupni_iznos === 0
        ) {
            store.addNotification({
                title: "Greška!",
                message: "Molimo odaberite barem jedan artikl i upišite cijenu",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                    duration: 5000,
                    pauseOnHover: true,
                },
            });
        } else {
            let stornirano = await clientIzdavanjeRacuna(
                this.state.pickedNapUred,
                this.state.pickedNacinPlacanja,
                this.state.articles
            );
            if (stornirano.data.status === 200) {
                store.addNotification({
                    title: "Uspješno!",
                    message: "Račun je uspješno izdan",
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animate__animated", "animate__fadeIn"],
                    animationOut: ["animate__animated", "animate__fadeOut"],
                    dismiss: {
                        duration: 5000,
                        pauseOnHover: true,
                    },
                });

                await this.setState({
                    pickedNapUred: {},
                    pickedNacinPlacanja: {},
                    articles: [
                        {
                            naziv: "",
                            kolicina: 1,
                            ukupni_iznos: 0,
                            jedinicna_cijena_mpc: 0,
                            uuid: "",
                        },
                    ],
                });
            } else {
                store.addNotification({
                    title: "Greška!",
                    message: stornirano.data.message,
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animate__animated", "animate__fadeIn"],
                    animationOut: ["animate__animated", "animate__fadeOut"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true,
                    },
                });
            }
        }

        this.setState({ loading: false });
    };

    appendInput() {
        //dodaj u articles
        let articlesCopy = [...this.state.articles];
        articlesCopy.push({
            naziv: "",
            kolicina: 1,
            ukupni_iznos: 0,
            uuid: "",
        });
        this.setState({ articles: articlesCopy });
    }

    removeArticle = async (input) => {
        let articlesCopy = this.state.articles;
        if (input !== -1) {
            articlesCopy.splice(input, 1);

            this.setState({ articles: articlesCopy });
        }
    };

    handleChange(e, key) {
        console.log(e.target);
        let updatedObj = Object.assign({}, this.state.articles[key], {
            [e.target.id]:
                e.target.id === "ukupni_iznos"
                    ? e.target.value
                    : e.target.value,
        });

        //update state value.
        this.setState({
            articles: [
                ...this.state.articles.slice(0, key),
                updatedObj,
                ...this.state.articles.slice(key + 1),
            ],
        });
    }

    setArticles = async (data, key) => {
        let updatedObj = Object.assign({}, this.state.articles[key], {
            name: data.label,
            uuid: data.value,
        });

        //update state value.
        this.setState({
            articles: [
                ...this.state.articles.slice(0, key),
                updatedObj,
                ...this.state.articles.slice(key + 1),
            ],
        });
        /*
        this.state.devices.filter(devices => devices.label === data.value).map(filteredData => (
            //this.props.mapState("CLIENT_MAP_PICKED_NAP_UREDAJ", filteredData) 
            console.log(filteredData) 
              
            this.setState({
                pickedNapUred: filteredData
            })  
                
        ))
        */
    };

    render() {
        return (
            <div style={{ margin: "40px 0px 40px 0px", padding: "20px" }}>
                {this.state.loading ? (
                    <>
                        <h2
                            style={{
                                textAlign: "center",
                                verticalAlign: "middle",
                                fontWeight: "600",
                                color: "rgb(22, 40, 111)",
                            }}
                        >
                            {this.state.poruka}
                        </h2>
                        <div
                            style={{
                                position: "sticky",
                                marginTop: "50px",
                                left: "50%",
                            }}
                        >
                            <Loader />
                        </div>
                    </>
                ) : (
                    <div className="container">
                        <div className="row">
                            <div className="col col-sm-12 col-lg-6 col-md-12">
                                <div className="form-group row">
                                    <label
                                        htmlFor="listNapUredOption"
                                        className="col-sm-6 col-form-label"
                                    >
                                        Naplatni uređaj
                                    </label>
                                    <div className="col-sm-6">
                                        <Dropdown
                                            placeholder="Izaberite..."
                                            options={
                                                this.state.listNapUredOption
                                            }
                                            onChange={this.setNapUredaj}
                                            value={
                                                this.state.pickedNapUred
                                                    .description
                                                    ? this.state.pickedNapUred
                                                          .description
                                                    : ""
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col col-sm-12 col-lg-6 col-md-12">
                                <div className="form-group row">
                                    <label
                                        htmlFor="listNapUredOption"
                                        className="col-sm-6 col-form-label"
                                    >
                                        Način plaćanja{" "}
                                    </label>
                                    <div className="col-sm-6">
                                        <Dropdown
                                            placeholder="Izaberite..."
                                            options={
                                                this.state.listNacinPlacanja
                                            }
                                            onChange={this.setNacinPlacanja}
                                            value={
                                                this.state.naciniPlacanja
                                                    .description
                                                    ? this.state.naciniPlacanja
                                                          .description
                                                    : ""
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <br />
                        <br />

                        <header>
                            <h2>Stavke</h2>
                        </header>

                        <div id="dynamicInput">
                            {this.state.articles.map((data, key) => (
                                <div
                                    className="row"
                                    key={key}
                                    style={{ margin: "10px 0px 10px 0px" }}
                                >
                                    <div className="col col-sm-6 col-lg-5 col-md-6">
                                        <div className="form-group row">
                                            <label
                                                htmlFor="listNapUredOption"
                                                className="col-sm-3 col-form-label"
                                            >
                                                Naziv{" "}
                                            </label>
                                            <div className="col-sm-9">
                                                <Dropdown
                                                    id="naziv"
                                                    type="text"
                                                    placeholder="Izaberite..."
                                                    options={
                                                        this.state.listArtikli
                                                    }
                                                    onChange={(e) =>
                                                        this.setArticles(e, key)
                                                    }
                                                    value={data.naziv}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col col-sm-4 col-md-4 col-lg-3">
                                        <div className="form-group row">
                                            <label
                                                htmlFor="listNapUredOption"
                                                className="col-sm-3 col-form-label"
                                            >
                                                Iznos{" "}
                                            </label>
                                            <div className="col-sm-9">
                                                <input
                                                    id={"ukupni_iznos"}
                                                    type="number"
                                                    defaultValue={
                                                        data.ukupni_iznos
                                                    }
                                                    onChange={(e) =>
                                                        this.handleChange(
                                                            e,
                                                            key
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        className="col col-sm-1"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <div className="form-group row">
                                            <TiDelete
                                                size={36}
                                                color="red"
                                                onClick={() =>
                                                    this.removeArticle(key)
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="row">
                            <div className="col-sm-12 col-form">
                                <div
                                    className="btn btn-success"
                                    style={{
                                        float: "left",
                                        fontSize: "1.5rem",
                                    }}
                                    onClick={() => this.appendInput()}
                                >
                                    <BiAddToQueue /> Dodaj Stavku
                                </div>
                            </div>
                        </div>

                        <br />
                        <br />

                        <div className="form-group row">
                            <div
                                className="col-sm-12 col-form"
                                style={{ textAlign: "center" }}
                            >
                                <div
                                    className="btn btn-danger"
                                    style={{ fontSize: "1.5rem" }}
                                    onClick={() => this.izdavanjeRacuna()}
                                >
                                    <AiOutlineSend /> Izdaj račun
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data }),
        API: (type, data) => dispatch({ type: type, data: data }),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(IzdavanjeRacuna);
